import { useQuery } from '@tanstack/react-query';
import { Billing, BillingUsageProps } from '@ixicare/resources';
import { BillingNodeRow } from './orgTree';

export interface BillingRow extends BillingNodeRow {
  usage: BillingUsageProps;
}

// Fetches one `/billing/usage` call per row (org subtree total or single-site
// total) in parallel, and zips the results back onto the ordered rows. `cacheKey`
// identifies the current selection (an org id or the no-org sentinel).
export function useBillingBreakdown(
  rows: BillingNodeRow[] | undefined,
  cacheKey: string | null,
  year: number,
  month: number
) {
  return useQuery({
    queryKey: ['billingBreakdown', cacheKey, year, month],
    enabled: !!rows && rows.length > 0,
    queryFn: async (): Promise<BillingRow[]> => {
      const usages = await Promise.all(rows!.map((row) => Billing.getBillingUsage({ ...row.scope, year, month })));
      return rows!.map((row, index) => ({ ...row, usage: usages[index] }));
    },
  });
}
